import React from 'react';
import PropTypes from 'prop-types';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { isAudienceNativeAdsCampaign, isAudienceCTVCampaign, isAudienceDealCampaign } from '@bingads-webui-campaign-react/constants';
import { Layout } from '@bingads-webui-react/wizard';
import { ErrorBar } from '@bingads-webui-fluent-component/wizard-ui-library';

import { WIZARD_TYPE_TO_FLOW, WIZARD_TYPES } from '../step-constants';
import { DisplayPlusWizard } from './wizard';
import { StepList } from '../step-list';
import { AdGroupCreationFooter } from '../footers';

const getWizardType = (currentCampaign) => {
  if (isAudienceNativeAdsCampaign(currentCampaign.CampaignSubType)) {
    return WIZARD_TYPES.AUDIENCE_AD_GROUP_CREATION;
  }

  if (isAudienceCTVCampaign(currentCampaign)) {
    return WIZARD_TYPES.AUDIENCE_AD_GROUP_CTV_CREATION;
  }

  if (isAudienceDealCampaign(currentCampaign)) {
    return WIZARD_TYPES.AUDIENCE_AD_GROUP_DEAL_CREATION;
  }

  return WIZARD_TYPES.AUDIENCE_AD_GROUP_CREATION;
};

const DisplayPlusCreateAdGroupWizardInternal = ({
  currentCampaign, currentAdGroup, siteMap, perfMarker,
}) => {
  const routeToNavigateToWhenDone = getRoutePathById(siteMap, 'adgroups');

  const wizardType = getWizardType(currentCampaign);
  const flowType = WIZARD_TYPE_TO_FLOW[wizardType];

  return (
    <DisplayPlusWizard
      wizardType={wizardType}
      flowType={flowType}
      routeToNavigateToWhenDone={routeToNavigateToWhenDone}
      initialWizardData={{
        campaign: currentCampaign,
        adGroup: currentAdGroup,
      }}
      perfMarker={perfMarker}
    >
      <Layout type="StepList" component={StepList} />
      <Layout type="ErrorBar" component={ErrorBar} />
      <Layout
        type="Footer"
        component={AdGroupCreationFooter}
        nextButtonText={_TL_('Save & go to next step')}
      />
    </DisplayPlusWizard>
  );
};

DisplayPlusCreateAdGroupWizardInternal.propTypes = {
  siteMap: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  currentCampaign: PropTypes.shape({
    CampaignSubType: PropTypes.number.isRequired,
  }).isRequired,
  currentAdGroup: PropTypes.shape({}).isRequired,
};

export const DisplayPlusCreateAdGroupWizard = withSiteMap(DisplayPlusCreateAdGroupWizardInternal);
